<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Create Segment
            </h2>
        </template>

        <segment-form
            :partners="partners"
            :verticals="verticals"
            :domains="domains"
            :action="route('segments.store')"
            method="POST"
            button="CREATE"
        />
    </app-layout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout';
    import SegmentForm from './Form';

    export default {
        components: {
            AppLayout,
            SegmentForm: SegmentForm,
        },

        props: ['partners', 'verticals', 'domains'],
    }
</script>
